module.exports = __webpack_public_path__ + "img/logotype.e3a1c022.svg";